import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Thumb = styled.img`
  border-radius: 3px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15);
  display: block;
  max-height: 90px;
  max-width: 30%;
  opacity: 0.7;
  transition: box-shadow 0.2s, border-color 0.2s, opacity 0.2s;
  &:not(last-child) {
    margin-right: 5px;
    @media (max-width: 599px) {
      margin-right: 12px;
    }
  }
  &:hover {
    cursor: pointer;
    opacity: 1;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5);
  }
`;

class ImageThumb extends Component {
  static propTypes = {
    handleMouseOver: PropTypes.func,
    image: PropTypes.string,
    index: PropTypes.number
  };

  render() {
    const { handleMouseOver, index, image } = this.props;
    return (
      <Thumb
        alt={`thumbnail${index + 1}`}
        src={image}
        onClick={() => handleMouseOver(index)}
        onMouseOver={() => handleMouseOver(index)}
        onTouchStart={() => handleMouseOver(index)}
      />
    );
  }
}

export default ImageThumb;



// WEBPACK FOOTER //
// ./src/components/Steps/ImageThumb.js